import { STATUS_IN_SUPERVISOR_REVIEW, STATUS_GENERATED, STATUS_COMPLETED } from 'constants/report_status';

// Status so that the nurse writer does not enter the comparison view
export const NOT_ACCESS_REPORT_COMPARATION = [STATUS_IN_SUPERVISOR_REVIEW.id, STATUS_GENERATED.id, STATUS_COMPLETED.id];
